import { UseSearchState } from '@propertypal/shared/src/hooks/useSearchState';
import { SearchState } from '@propertypal/shared/src/reducers/search';
import CheckItem from '@propertypal/web-ui/src/inputs/CheckItem';
import { Column } from '@propertypal/web-ui/src/layout';
import { InputLabel } from '@propertypal/web-ui/src/typography';
import React, { FunctionComponent } from 'react';
import { PreferenceColumn, PreferenceColumnContainer, PreferencePill, PreferenceRow } from './SearchBar.style';

interface Props {
  filters: SearchState['filters'];
  handleFilterChange: UseSearchState['handleFilterChange'];
  isRental: boolean;
  isNewHomes: boolean;
}

const PreferenceInputs: FunctionComponent<Props> = ({ filters, handleFilterChange, isRental, isNewHomes }) => {
  const indoor = [
    <CheckItem
      ariaLabel="Select properties with an Ensuite"
      label="Ensuite"
      checked={(filters.tags && filters.tags.includes('ensuite')) || false}
      onValueChange={handleFilterChange('tags-ensuite')}
      testID="checkItem-includeEnsuite"
      key="ensuite"
    />,
    // <CheckItem
    //   ariaLabel="Select properties with a Loft Conversion"
    //   label="Loft Conversion"
    //   checked={(filters.tags && filters.tags.includes('loftConversion')) || false}
    //   onValueChange={handleFilterChange('tags-loftConversion')}
    //   testID="checkItem-includeLoftConversion"
    //   key="loftConversion"
    // />,
    // <CheckItem
    //   ariaLabel="Select properties with an Open Fireplace"
    //   label="Open Fireplace"
    //   checked={(filters.tags && filters.tags.includes('openFireplace')) || false}
    //   onValueChange={handleFilterChange('tags-openFireplace')}
    //   testID="checkItem-includeOpenFireplace"
    //   key="openFireplace"
    // />,
    // <CheckItem
    //   ariaLabel="Select properties with an Open Living Space"
    //   label="Open Living Space"
    //   checked={(filters.tags && filters.tags.includes('openLivingSpace')) || false}
    //   onValueChange={handleFilterChange('tags-openLivingSpace')}
    //   testID="checkItem-includeOpenLivingSpace"
    //   key="openLivingSpace"
    // />,
    <CheckItem
      ariaLabel="Select properties with a Utility Room"
      label="Utility Room"
      checked={(filters.tags && filters.tags.includes('utilityRoom')) || false}
      onValueChange={handleFilterChange('tags-utilityRoom')}
      testID="checkItem-includeUtilityRoom"
      key="utilityRoom"
    />,
    <CheckItem
      ariaLabel="Select properties with a Downstairs WC"
      label="Downstairs WC"
      checked={(filters.tags && filters.tags.includes('downstairsToilet')) || false}
      onValueChange={handleFilterChange('tags-downstairsToilet')}
      testID="checkItem-includeDownstairsToilet"
      key="downstairsToilet"
    />,
  ];

  const garage = [
    <CheckItem
      ariaLabel="Select properties with a Garage"
      label="Garage"
      checked={filters.garage && !filters.largeGarage}
      onValueChange={handleFilterChange('garage')}
      testID="checkItem-includeGarage"
      key="garage"
    />,
    <CheckItem
      ariaLabel="Select properties with a Large Garage"
      label="Large Garage"
      checked={filters.largeGarage && !filters.garage}
      onValueChange={handleFilterChange('largeGarage')}
      testID="checkItem-includeLargeGarage"
      key="largeGarage"
    />,
  ];

  const outdoor = [
    <CheckItem
      ariaLabel="Select properties with a Garden"
      label="Garden"
      checked={(filters.tags && filters.tags.includes('garden')) || false}
      onValueChange={handleFilterChange('tags-garden')}
      testID="checkItem-includeGarden"
      key="garden"
    />,
    <CheckItem
      ariaLabel="Select properties with a Patio"
      label="Patio"
      checked={(filters.tags && filters.tags.includes('patio')) || false}
      onValueChange={handleFilterChange('tags-patio')}
      testID="checkItem-includePatio"
      key="patio"
    />,
    // <CheckItem
    //   ariaLabel="Select properties with a South Facing Garden"
    //   label="South Facing Garden"
    //   checked={(filters.tags && filters.tags.includes('southFacingGarden')) || false}
    //   onValueChange={handleFilterChange('tags-southFacingGarden')}
    //   testID="checkItem-includeSouthFacingGarden"
    //   key="southFacingGarden"
    // />,
    <CheckItem
      ariaLabel="Select properties with Space for a Horse"
      label="Space for a Horse"
      checked={(filters.tags && filters.tags.includes('roomForAHorse')) || false}
      onValueChange={handleFilterChange('tags-roomForAHorse')}
      testID="checkItem-includeRoomForAHorse"
      key="roomForAHorse"
    />,
  ];

  const parking = [
    <CheckItem
      ariaLabel="Select properties with a Driveway"
      label="Driveway"
      checked={(filters.tags && filters.tags.includes('driveway')) || false}
      onValueChange={handleFilterChange('tags-driveway')}
      testID="checkItem-includeDriveway"
      key="driveway"
    />,
    <CheckItem
      ariaLabel="Select properties with a Off Street Parking"
      label="Off Street Parking"
      checked={(filters.tags && filters.tags.includes('offStreetParking')) || false}
      onValueChange={handleFilterChange('tags-offStreetParking')}
      testID="checkItem-includeOffStreetParking"
      key="offStreetParking"
    />,
    // <CheckItem
    //   ariaLabel="Select properties with a Allocated Parking"
    //   label="Allocated Parking"
    //   checked={(filters.tags && filters.tags.includes('allocatedParking')) || false}
    //   onValueChange={handleFilterChange('tags-allocatedParking')}
    //   testID="checkItem-includeAllocatedParking"
    //   key="allocatedParking"
    // />,
  ];

  const other = [
    <CheckItem
      ariaLabel="Select properties in a Cul-de-sac"
      label="Cul-de-sac"
      checked={(filters.tags && filters.tags.includes('culDeSac')) || false}
      onValueChange={handleFilterChange('tags-culDeSac')}
      testID="checkItem-includeCulDeSac"
      key="culDeSac"
    />,
    <CheckItem
      ariaLabel="Select properties with Disabled Access"
      label="Disabled Access"
      checked={(filters.tags && filters.tags.includes('disabledAccess')) || false}
      onValueChange={handleFilterChange('tags-disabledAccess')}
      testID="checkItem-includeDisabledAccess"
      key="disabledAccess"
    />,
    // <CheckItem
    //   ariaLabel="Select properties with an Eco Home"
    //   label="Eco Home"
    //   checked={(filters.tags && filters.tags.includes('ecoHome')) || false}
    //   onValueChange={handleFilterChange('tags-ecoHome')}
    //   testID="checkItem-includeEcoHome"
    //   key="ecoHome"
    // />,
    <CheckItem
      ariaLabel="Select properties with Sea Views"
      label="Sea Views"
      checked={(filters.tags && filters.tags.includes('seaViews')) || false}
      onValueChange={handleFilterChange('tags-seaViews')}
      testID="checkItem-includeSeaViews"
      key="seaViews"
    />,
    <CheckItem
      ariaLabel="Select properties with Solar Panels"
      label="Solar Panels"
      checked={(filters.tags && filters.tags.includes('solarPanels')) || false}
      onValueChange={handleFilterChange('tags-solarPanels')}
      testID="checkItem-includeSolarPanels"
      key="solarPanels"
    />,
    <CheckItem
      ariaLabel="Select properties with a Swimming Pool"
      label="Swimming Pool"
      checked={(filters.tags && filters.tags.includes('swimmingPool')) || false}
      onValueChange={handleFilterChange('tags-swimmingPool')}
      testID="checkItem-includeSwimmingPool"
      key="swimmingPool"
    />,
    !isRental && (
      <CheckItem
        ariaLabel="Select Cash Sale Properties"
        label="Cash Sale"
        checked={(filters.tags && filters.tags.includes('cashSale')) || false}
        onValueChange={handleFilterChange('tags-cashSale')}
        testID="checkItem-includeCashSale"
        key="cashSale"
      />
    ),
    <CheckItem
      ariaLabel="Select properties in a Rural Area"
      label="Rural Area"
      checked={(filters.tags && filters.tags.includes('rural')) || false}
      onValueChange={handleFilterChange('tags-rural')}
      testID="checkItem-rural"
      key="rural"
    />,
    <CheckItem
      ariaLabel="Select properties with an Annex"
      label="With Annex"
      checked={(filters.tags && filters.tags.includes('annex')) || false}
      onValueChange={handleFilterChange('tags-annex')}
      testID="checkItem-annex"
      key="annex"
    />,
  ];

  const condition = [
    !isRental && (
      <CheckItem
        ariaLabel="Select properties In Need of Modernisation"
        label="In Need of Modernisation"
        checked={(filters.tags && filters.tags.includes('refurbishmentOportunity')) || false}
        onValueChange={handleFilterChange('tags-refurbishmentOportunity')}
        testID="checkItem-includeRefurbishmentOportunity"
        key="refurbishmentOportunity"
      />
    ),
    !isRental && (
      <CheckItem
        ariaLabel="Select Investment Opportunity properties"
        label="Investment Opportunity"
        checked={(filters.tags && filters.tags.includes('investmentPotential')) || false}
        onValueChange={handleFilterChange('tags-investmentPotential')}
        testID="checkItem-includeInvestmentPotential"
        key="investmentPotential"
      />
    ),
    !isRental && (
      <CheckItem
        ariaLabel="Select properties that are a Listed Building"
        label="Listed Building"
        checked={(filters.tags && filters.tags.includes('listedBuilding')) || false}
        onValueChange={handleFilterChange('tags-listedBuilding')}
        testID="checkItem-includeListedBuilding"
        key="listedBuilding"
      />
    ),
    <CheckItem
      ariaLabel="Select properties that are a Recently Refurbished"
      label="Recently Refurbished"
      checked={(filters.tags && filters.tags.includes('recentlyRefurbished')) || false}
      onValueChange={handleFilterChange('tags-recentlyRefurbished')}
      testID="checkItem-includeRecentlyRefurbished"
      key="recentlyRefurbished"
    />,
  ];

  // const exclude = [
  //   <CheckItem
  //     ariaLabel="Exclude properties that are Non-Mortgageable"
  //     label="Non-Mortgageable"
  //     checked={(filters.excludeTags && filters.excludeTags.includes('nonMortgageable')) || false}
  //     onValueChange={handleFilterChange('excludeTags-nonMortgageable')}
  //     testID="checkItem-excludeNonMortgageable"
  //     key="nonMortgageable"
  //   />,
  //   <CheckItem
  //     ariaLabel="Exclude Cash Sale properties"
  //     label="Cash Sale"
  //     checked={(filters.excludeTags && filters.excludeTags.includes('cashSale')) || false}
  //     onValueChange={handleFilterChange('excludeTags-cashSale')}
  //     testID="checkItem-excludeCashSale"
  //     key="cashSale"
  //   />,
  //   <CheckItem
  //     ariaLabel="Exclude Lapsed Planning Permission properties"
  //     label="Lapsed Planning Permission"
  //     checked={(filters.excludeTags && filters.excludeTags.includes('lapsedPlanningPermission')) || false}
  //     onValueChange={handleFilterChange('excludeTags-lapsedPlanningPermission')}
  //     testID="checkItem-excludeLapsedPlanningPermission"
  //     key="lapsedPlanningPermission"
  //   />,
  //   <CheckItem
  //     ariaLabel="Exclude Building Control Issue properties"
  //     label="Building Control Issue"
  //     checked={(filters.excludeTags && filters.excludeTags.includes('buildingControlIssue')) || false}
  //     onValueChange={handleFilterChange('excludeTags-buildingControlIssue')}
  //     testID="checkItem-excludeBuildingControlIssue"
  //     key="buildingControlIssue"
  //   />,
  //   <CheckItem
  //     ariaLabel="Exclude Building Work Required properties"
  //     label="Building Work Required"
  //     checked={(filters.excludeTags && filters.excludeTags.includes('buildingWorkRequired')) || false}
  //     onValueChange={handleFilterChange('excludeTags-buildingWorkRequired')}
  //     testID="checkItem-excludeBuildingWorkRequired"
  //     key="buildingWorkRequired"
  //   />,
  //   <CheckItem
  //     ariaLabel="Exclude Partially Finished properties"
  //     label="Partially Finished"
  //     checked={(filters.excludeTags && filters.excludeTags.includes('partiallyFinishedFeature')) || false}
  //     onValueChange={handleFilterChange('excludeTags-partiallyFinishedFeature')}
  //     testID="checkItem-excludePartiallyFinishedFeature"
  //     key="partiallyFinishedFeature"
  //   />,
  //   <CheckItem
  //     ariaLabel="Exclude Building Defect properties"
  //     label="Building Defect"
  //     checked={(filters.excludeTags && filters.excludeTags.includes('buildingDefect')) || false}
  //     onValueChange={handleFilterChange('excludeTags-buildingDefect')}
  //     testID="checkItem-excludeBuildingDefect"
  //     key="buildingDefect"
  //   />,
  //   <CheckItem
  //     ariaLabel="Exclude Non Standard Construction properties"
  //     label="Non Standard Construction"
  //     checked={(filters.excludeTags && filters.excludeTags.includes('nonStandardConstruction')) || false}
  //     onValueChange={handleFilterChange('excludeTags-nonStandardConstruction')}
  //     testID="checkItem-excludeNonStandardConstruction"
  //     key="nonStandardConstruction"
  //   />,
  // ];

  return (
    <Column w="100%">
      <InputLabel mt={20}>Preferences</InputLabel>
      <PreferenceColumnContainer>
        <PreferenceColumn>
          <PreferencePill>Indoor</PreferencePill>
          <PreferenceRow>{indoor}</PreferenceRow>
        </PreferenceColumn>
        <PreferenceColumn>
          <PreferencePill>Garage</PreferencePill>
          <PreferenceRow>{garage}</PreferenceRow>
        </PreferenceColumn>
      </PreferenceColumnContainer>
      <PreferenceColumnContainer>
        <PreferenceColumn>
          <PreferencePill>Outdoor</PreferencePill>
          <PreferenceRow>{outdoor}</PreferenceRow>
        </PreferenceColumn>
        <PreferenceColumn>
          <PreferencePill>Parking</PreferencePill>
          <PreferenceRow>{parking}</PreferenceRow>
        </PreferenceColumn>
      </PreferenceColumnContainer>
      <PreferenceColumnContainer>
        <PreferenceColumn>
          <PreferencePill>Other</PreferencePill>
          <PreferenceRow>{other}</PreferenceRow>
        </PreferenceColumn>
      </PreferenceColumnContainer>
      {!isNewHomes && (
        <PreferenceColumnContainer>
          <PreferenceColumn>
            <PreferencePill>Condition</PreferencePill>
            <PreferenceRow>{condition}</PreferenceRow>
          </PreferenceColumn>
        </PreferenceColumnContainer>
      )}
      {/* <PreferenceColumnContainer>
        <PreferenceColumn>
          <PreferencePill>Exclude</PreferencePill>
          <PreferenceRow>{exclude}</PreferenceRow>
        </PreferenceColumn>
      </PreferenceColumnContainer> */}
    </Column>
  );
};

export default PreferenceInputs;
